module.exports = __webpack_public_path__ + "static/pp_logo-ed25f37b7d7a3f3ac0c6f0c40bd45f21.jpg";